export const CLICKABLE_TAGS = new Set(['A', 'FIGURE', 'IMG', 'VIDEO', 'RW-HIGHLIGHT', 'SVG']);
export const CLICKABLE_TAGS_SELECTOR = Array.from(CLICKABLE_TAGS).join(', ').toLowerCase();

export const PAGINATION_DOCUMENT_TOP_MARGIN = 2000;
